/*
Raghu  26/10/2022   3075154998   Table Enhancements
akhila 11/01/2022 3075154998 TablePagination bugFix
saikrishna 11/03/2022 3075154998 changed the paginationOptions
Suresh Peddavoora 11/03/2022 3075154998 Table Pagination Tab Responsive Fix
akhila 11/01/2022 3075154998 TablePagination bugFix
Dilip 11/03/2022  3075154998 added action type to delete popup

*/
import React, {createRef, useState} from 'react';
// import MaterialTable from "material-table";
import {tableIcons} from '../../../../../../components/TableIcons';
import DeleteTableRecordPopup from '../../../../../../util/DeleteTableRecordPopup';
import GuiTable from '../../../../../../components/FormComponents/GuiTable';
import EditOutlinedIcon from '@material-ui/icons/EditOutlined';
import DeleteOutlineOutlinedIcon from '@material-ui/icons/DeleteOutlineOutlined';
import {defaultRows} from '../../../../../../constants/ReusableTablePagination';
import {TablePagination} from '@material-ui/core';
import {tablePageRows} from '../../../../../../constants/ReusableConstants';

export default function ActionTable({
  actionData,
  setActionData,
  setActionRowData,
  setIsEditMode,
  setActionCode,
  deleteAction,
  setDeleteAction,
}) {
  const columns = [
    {
      title: 'Seq No',
      field: 'seqNo',
      headerStyle: {
        textAlign: 'center',
      },
      cellStyle: {
        maxWidth: 200,
        textAlign: 'center',
      },
      render: (rowData) => {
        const rowSeqNo = rowData?.tableData?.id ?
          rowData?.tableData?.id + 1 :
          rowData?.tableData?.id === 0 ?
            1 :
            '';
        actionData[rowData.tableData.id].seqNo = rowSeqNo;
        return rowSeqNo;
      },
    },
    {
      title: 'Action Type',
      field: 'type',
      headerStyle: {
        textAlign: 'left',
      },
      cellStyle: {
        maxWidth: 200,
      },
    },
    {
      title: 'Expressions',
      field: 'expression',
      headerStyle: {
        textAlign: 'left',
      },
      minWidth: '400px',
    },
  ];

  const [rows, setRows] = useState(defaultRows);
  const tableRef = createRef();
  const [isDelete, setIsDelete] = useState(false);
  const [deleteData, setDeleteData] = useState({});
  const tableDataAction = actionData ?
    actionData?.map((item, i) => ({
      ...item,
      id: i,
    })) :
    [];

  const handleActionEdit = (rowData) => {
    setIsEditMode(true);
    setActionRowData(rowData);
  };
  const handleDelete = (rowData) => {
    setIsDelete(true);
    setDeleteData(rowData);
  };
  const handleClose = () => {
    setIsDelete(false);
  };
  const handleSubmit = () => {
    setTimeout(() => {
      const data = [...actionData];
      const newData = data.filter((row, i) => row.sequenceNo !== deleteData.sequenceNo);
      const newDeletedIds = [...deleteAction];
      if (deleteData?.actionId) {
        newDeletedIds.push(deleteData?.actionId);
      }
      setDeleteAction(newDeletedIds);
      setActionData(newData);
    }, 1000);
    setIsDelete(false);
  };
  return (
    <div>
      <DeleteTableRecordPopup
        open={isDelete}
        dialogClose={handleClose}
        title="Delete Action"
        value={`Are you sure you want to delete this ${deleteData?.type} action?`}
        handleSubmit={handleSubmit}
      />
      <div className="custom-table global-field-table">
        <GuiTable
          title=""
          columns={columns}
          icons={tableIcons}
          tableRef={tableRef}
          data={tableDataAction}
          options={{
            search: false,
            toolbar: false,
            pageSize: rows,
            showSelectAllCheckbox: false,
            emptyRowsWhenPaging: false,
            headerStyle: {
              fontWeight: 'bold',
            },
          }}
          components={{
            Pagination: (props) => (
              <div className="global-field-table-footer ">
                <div className="mt-2">

                </div>
                <div>
                  <TablePagination
                    {...props}
                    SelectProps={{
                      inputProps: {'aria-label': 'Rows per screen'},
                    }}
                    labelRowsPerPage={'Rows per screen:'}
                    rowsPerPageOptions={tablePageRows}
                    onChangeRowsPerPage={(event) => {
                      props.onChangeRowsPerPage(event);
                      setRows(event.target.value);
                    }}
                  />
                </div>
              </div>
            ),
          }}
          actions={[
            {
              icon: () => <EditOutlinedIcon/>,
              tooltip: 'Edit',
              onClick: (event, rowData) => {
                handleActionEdit(rowData);
                setActionCode(rowData.id);
              },
            },
            {
              icon: () => <DeleteOutlineOutlinedIcon/>,
              tooltip: 'Delete',
              onClick: (event, rowData) => {
                handleDelete(rowData);
                setIsDelete(true);
              },
            },
          ]}
        />
      </div>
    </div>
  );
}
